import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './slices/cartSlice'; // Adjust the path based on your folder structure

const store = configureStore({
  reducer: {
    cart: cartReducer,
  },
});

export default store;
